export const AI_INTERVIEW_SCORE_HIDING_AVAILABLE_LABEL =
  'Allow roles to hide AI interview scores';

export const SWITCH_OFF_NOTIFICATION_MESSAGE =
  'Turning this off shows AI interview scores again on every role that hides them.';

export const AI_INTERVIEW_SCORE_HIDING_DATA_TEST_ID =
  'ai-interview-score-hiding-form';
